import { IOrientacaoCompleta } from "../../../utility/IOrientacaoCompleta";
import { IProposta } from "../../../utility/IProposta";

export function extrairOrientacoes(orientacoes: unknown[]): { orientacaoPrevia: string | null; orientacoesCompletas: IOrientacaoCompleta[] } {
    return orientacoes.reduce<{ orientacaoPrevia: string | null; orientacoesCompletas: IOrientacaoCompleta[] }>(
        (resultado, item) => {
            if (typeof item === "string" && !resultado.orientacaoPrevia) {
                const texto = item.trim();
                if (texto) {
                    resultado.orientacaoPrevia = texto;
                }
            } else if (item !== null && item !== undefined && typeof item === "object") {
                resultado.orientacoesCompletas.push(item as IOrientacaoCompleta);
            }
            return resultado;
        },
        { orientacaoPrevia: null, orientacoesCompletas: [] },
    );
}

export function verificarDemandaCancelada(demanda?: IProposta | null): boolean {
    return demanda?.status?.trim().toLowerCase() === "cancelada";
}

export function verificarDemandaConcluida(demanda?: IProposta | null): boolean {
    if (!demanda) {
        return false;
    }

    const temDataConclusao = typeof demanda.data_conclusao === 'string' && demanda.data_conclusao.trim().length > 0;
    
    if (temDataConclusao) {
        return true;
    }

    const statusNormalizado = demanda.status?.trim().toLowerCase();
    const statusValidos = ["em conferência", "finalizada", "cancelada"];
    
    const temHistoricoConclusao = (demanda as any)?.historico?.some((h: any) => 
        h.acao?.toLowerCase().includes('concluiu demanda')
    );
    
    return (statusValidos.some(status => statusNormalizado === status) && !!demanda?.info_conclusao) || 
           (temHistoricoConclusao && !!demanda?.info_conclusao);
}

export function verificarDemandaInterrompida(demanda?: IProposta | null): boolean {
    if (!demanda) {
        return false;
    }

    const statusNormalizado = demanda?.status?.trim().toLowerCase();
    const statusValidos = ["em conferência"];
    
    const temHistoricoInterrupcao = (demanda as any)?.historico?.some((h: any) => 
        h.acao?.toLowerCase().includes('interrompeu demanda')
    );
    
    return (statusValidos.some(status => statusNormalizado === status) && temHistoricoInterrupcao) ||
           !!demanda?.info_interrupcao;
}

export function verificarDemandaRecusada(demanda?: IProposta | null): boolean {
    if (!demanda?.status_finalizacao) {
        return false;
    }

    const statusNormalizado = demanda.status_finalizacao.trim().toLowerCase();

    return statusNormalizado === "recusada";
}

export function verificarDemandaFinalizada(demanda?: IProposta | null): boolean {
    if (!demanda) {
        return false;
    }

    const statusNormalizado = demanda.status?.trim().toLowerCase();
    
    const temHistoricoFinalizacao = (demanda as any)?.historico?.some((h: any) => {
        const acaoLower = h.acao?.toLowerCase() || '';
        return acaoLower.includes('demanda finalizada') || 
               acaoLower.includes('finalizou demanda com aceite') ||
               acaoLower.includes('finalizou demanda com recusa');
    });
    
    return statusNormalizado === "finalizada" && (!!demanda?.info_finalizacao || temHistoricoFinalizacao);
}

export function verificarStatusBloqueadoOrientacaoCompleta(demanda?: IProposta | null): { bloqueado: boolean; statusAtual: string } {
    if (!demanda?.status) {
        return { bloqueado: false, statusAtual: "" };
    }

    const statusNormalizado = demanda.status.trim().toLowerCase();
    const statusBloqueados = ["pendente", "em triagem", "cancelada"];

    const bloqueado = statusBloqueados.includes(statusNormalizado);

    return { bloqueado, statusAtual: demanda.status.trim() };
}

